export const UPDATE_CAREER_FINANCIALS_DATA: string =
    'UPDATE_CAREER_FINANCIALS_DATA';
export const RESET_CAREER_FINANCIALS_DATA: string =
    'RESET_CAREER_FINANCIALS_DATA';
